import React from 'react'

export default function ExampleTemplate3({ primaryColour, textColour, backgroundColour, headingFont, bodyFont, logo }) {
    return (
        <div
            style={{
                backgroundColor: '#eeeeed',
                borderRadius: '12px',
                height: '250px',
                overflow: 'scroll',
                display: 'flex',
                flexDirection: 'column',
                padding: '20px',
                paddingBottom: '0px'
            }}
        >
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <img
                    src={logo ? logo.url || logo.raw : ''}
                    style={{ width: '100%', maxWidth: '30px', maxHeight: '30px' }}
                />
            </div>

            <div style={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                <div style={{ width: '100%', backgroundColor: backgroundColour, padding: '6px' }}></div>

                <div>
                    <img
                        src='https://cdn1.ourmailsender.com/siteContent/brandAnalyzer/example3_img1.png'
                        style={{ width: '100%' }}
                    />
                </div>

                <div style={{ padding: '15px', color: textColour }}>
                    <div
                        style={{
                            fontSize: '13px',
                            fontWeight: 'bold',
                            marginBottom: '10px',
                            textAlign: 'center',
                            fontFamily: headingFont
                        }}
                    >
                        Good things are coming!
                    </div>
                    <div
                        style={{
                            fontSize: '8px',
                            marginBottom: '10px',
                            lineHeight: '12px',
                            textAlign: 'center',
                            fontFamily: bodyFont
                        }}
                    >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.{' '}
                        <a style={{ color: primaryColour }}>Click Here</a>. Aenean auctor cursus eros vel suscipit. Ut
                        eleifend massa ac velit iaculis, nec convallis nisi rutrum. Fusce varius hendrerit arcu.
                    </div>
                </div>
            </div>
        </div>
    )
}
